import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "主题专题", to: "/category/topic" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-clapperboard-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                年轻的母亲在线
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              年轻的母亲在线是一个聚焦“年轻的母亲”主题影视内容的在线资源平台，同时涵盖电影、电视剧等丰富影视资源，为影视爱好者提供便捷的查找、筛选与剧情介绍浏览体验。
            </p>
            <p className="mt-4 text-xs text-background-300">
              本站影视信息均为虚构示例数据，仅用于页面演示，不提供播放与下载功能。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              内容导航
            </h3>
            <ul className="space-y-2.5">
              {FRIEND_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              联系我们
            </h3>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@ymm-online.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </span>
                微信公众号：年轻的母亲在线
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                每日持续更新影视资源
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 年轻的母亲在线 · 影视资源在线观看平台
          </p>
          <p className="text-xs text-background-300">
            内容仅供学习与演示使用 · 请支持正版影视作品
          </p>
        </div>
      </div>
    </footer>
  );
}